import React, { useState, useEffect } from 'react';
import axios from 'axios';
const { API_BASE_URL } = require('./Constants');

const GeneralMessages = (props) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const flag = props.flag; // Currently unused, but can be used for future features

  // Fetch messages from Laravel API
  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/inbox`);
      setMessages(res.data);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  // Send new message
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/inbox`, {
        message: newMessage,
        // No need to send sender_id as the backend will use "Matrix Learn"
      });
      
      setNewMessage('');
      fetchMessages();
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      setLoading(false);
    }
  };

  // Delete message
  const deleteMessage = async (messageId) => {
    if (!window.confirm('Are you sure you want to delete this message?')) {
      return;
    }

    setDeletingId(messageId);
    try {
      await axios.delete(`${API_BASE_URL}/api/inbox/${messageId}`);
      fetchMessages(); // Refresh the list after deletion
    } catch (error) {
      console.error('Error deleting message:', error);
      alert('Error deleting message. Please try again.');
    } finally {
      setDeletingId(null);
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-base-200 p-6">
      <div className="max-w-full mx-auto bg-base-100 rounded-xl shadow-sm overflow-hidden">
        <div className="p-6">
          <h1 className="text-3xl font-bold text-center mb-6">Messages</h1>
          
          {/* Message Input Form */}
          {flag &&   <form onSubmit={sendMessage} className="flex gap-2">
            <input
              type="text"
              placeholder="Type your message here..."
              className="input input-bordered flex-grow"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              disabled={loading}
            />
            <button 
              type="submit" 
              className={`btn btn-primary ${loading ? 'loading' : ''}`}
              disabled={!newMessage.trim() || loading}
            >
              Send
            </button>
          </form>
          }
          {/* Messages Display */}
          <div className="bg-base-200 rounded-lg p-4 mb-6 h-96 overflow-y-auto">
            {messages.length === 0 ? (
              <div className="flex items-center justify-center h-full">
                <p className="text-gray-500">No messages yet. Start a conversation!</p>
              </div>
            ) : (
              <div className="space-y-4">
                {messages.map((message, index) => (
                  <div key={message.id} className="relative">
                    <div className="chat chat-start">
                      <div className="chat-image avatar">
                        <div className="w-10 rounded-full bg-primary text-primary-content flex items-center justify-center text-center">
                          {'M'}
                        </div>
                      </div>
                      <div className="chat-header mb-1">
                        {'Matrix Learn'}
                        <time className="text-xs opacity-50 ml-2">
                          {new Date(message.created_at).toLocaleTimeString()}
                        </time>
                      </div>
                      <div className="chat-bubble">
                        {message.message}
                      </div>
                      <div className="chat-footer opacity-50 text-xs mt-1">
                        {new Date(message.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    
                    {/* Delete Button */}
                    {flag && (
                    <div className="absolute top-2 right-2">
                      <button
                        onClick={() => deleteMessage(message.id)}
                        disabled={deletingId === message.id}
                        className={`btn btn-sm btn-error ${deletingId === message.id ? 'loading' : ''}`}
                      >
                        {deletingId === message.id ? 'Deleting...' : 'Delete'}
                      </button>
                    </div>
                    )}
                    
                    {/* Horizontal line between messages */}
                    {index < messages.length - 1 && (
                      <hr className="my-4 border-gray-300" />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralMessages;